import {LOADED, LOADING} from "@/actions/types";

export const loading = () => (dispatch: (any:any) => void) => {
    dispatch({
        type: LOADING,
    });
};

export const loaded = () => (dispatch: (any:any) => void) => {
    dispatch({
        type: LOADED,
    });
};